import {Component, OnDestroy} from '@angular/core';
import {Subject} from "rxjs";

export function AngularDummyDecorator(): ClassDecorator {
  return (target: any) => {};
}

@AngularDummyDecorator()
export abstract class BaseComponent implements OnDestroy {

  public ngUnsubscribe = new Subject<void>();

  ionViewDidEnter() {
    this.recalcMarginHeight();
  }

  recalcMarginHeight() {
    const header = document.querySelector('ion-header') as HTMLElement;
    const mainContent = document.querySelector('#main') as HTMLElement;
    const appMenu = document.querySelector('ion-menu') as HTMLElement;

    if (!header) return;

    const headerHeight = header.offsetHeight + 'px';

    if (mainContent) {
      mainContent.style.marginTop = headerHeight;
    }

    if (appMenu) {
      appMenu.style.marginTop = headerHeight;
      appMenu.style.height = 'calc(100vh - '+headerHeight+')';
    }
  }

  ionViewWillLeave() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // ionViewWillLeave() n'est déclenché que pour les pages hébergées par ion-router-outlet.
  // ngOnDestroy() est garanti par Angular pour tout composant détruit (page ou enfant *ngIf),
  // donc c'est ici le filet de sécurité réel contre les fuites d'abonnements RxJS.
  // Subject.complete() est idempotent : l'appeler deux fois (ex: page qui a déjà déclenché
  // ionViewWillLeave) ne pose aucun problème.
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
